import React from "react";

export default function CurrentStock(props) {
  return <td> {props.quantity} units </td>;
}
